"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
var _rainbowSurge = require("./categorical/rainbowSurge");
Object.keys(_rainbowSurge).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _rainbowSurge[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _rainbowSurge[key];
    }
  });
});
var _blueberryTwilight = require("./categorical/blueberryTwilight");
Object.keys(_blueberryTwilight).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _blueberryTwilight[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _blueberryTwilight[key];
    }
  });
});
var _mangoFusion = require("./categorical/mangoFusion");
Object.keys(_mangoFusion).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mangoFusion[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mangoFusion[key];
    }
  });
});
var _cheerfulFiesta = require("./categorical/cheerfulFiesta");
Object.keys(_cheerfulFiesta).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _cheerfulFiesta[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _cheerfulFiesta[key];
    }
  });
});
var _strawberrySky = require("./sequential/strawberrySky");
Object.keys(_strawberrySky).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _strawberrySky[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _strawberrySky[key];
    }
  });
});
var _blue = require("./sequential/blue");
Object.keys(_blue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _blue[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _blue[key];
    }
  });
});
var _cyan = require("./sequential/cyan");
Object.keys(_cyan).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _cyan[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _cyan[key];
    }
  });
});
var _green = require("./sequential/green");
Object.keys(_green).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _green[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _green[key];
    }
  });
});
var _orange = require("./sequential/orange");
Object.keys(_orange).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _orange[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _orange[key];
    }
  });
});
var _pink = require("./sequential/pink");
Object.keys(_pink).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _pink[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _pink[key];
    }
  });
});
var _purple = require("./sequential/purple");
Object.keys(_purple).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _purple[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _purple[key];
    }
  });
});
var _red = require("./sequential/red");
Object.keys(_red).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _red[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _red[key];
    }
  });
});
var _yellow = require("./sequential/yellow");
Object.keys(_yellow).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _yellow[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _yellow[key];
    }
  });
});